import React from "react"
// import { DateTime } from "luxon"
import "semantic-ui-css/semantic.min.css"
import {
  Table,
  TableRow,
  TableHeaderCell,
  TableHeader,
  TableBody,
} from "semantic-ui-react"

import TransactionRow from './TransactionRow'

const TransactionsTable = ({
  currentPageBankTransfers = [],
  onRowClick = () => {},
  getBankTransferRowBgColor = () => { },
  onSetBankTransferReconciledPress = () => { },
} = {}) => {
  return (
    <Table celled>
      <TableHeader>
        <TableRow>
          <TableHeaderCell className="transaction-headercell">
            Delta Amount
          </TableHeaderCell>
          <TableHeaderCell className="transaction-headercell">
            Status
          </TableHeaderCell>
          <TableHeaderCell className="transaction-headercell">
            Date
          </TableHeaderCell>
          <TableHeaderCell className="transaction-headercell">
            Label
          </TableHeaderCell>
          <TableHeaderCell className="transaction-headercell">
            Amount
          </TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {currentPageBankTransfers.map((bankTransfer, index) => {
          return (
            <TransactionRow
              bankTransfer={bankTransfer}
              onRowClick={onRowClick}
              getBankTransferRowBgColor={getBankTransferRowBgColor}
              onSetBankTransferReconciledPress={onSetBankTransferReconciledPress}
              index={index}
            />
          )
        })}
      </TableBody>
    </Table>
  )
}

export default TransactionsTable
